// SQLite пишет CURRENT_TIMESTAMP в UTC и возвращает строки вида "2026-05-06 10:30:45"
// (без суффикса часового пояса). Если такую строку отдать new Date(), браузер
// распарсит её как ЛОКАЛЬНОЕ время — и в Ташкенте получится отставание на 5 часов.
// parseUtcDate явно трактует входную строку как UTC; число (timestamp ms) и Date
// пропускаются как есть.
export function parseUtcDate(input) {
  if (input == null) return null;
  if (input instanceof Date) return input;
  if (typeof input === 'number') return new Date(input);

  const s = String(input).trim();
  if (!s) return null;

  // Уже есть зона (Z или ±HH:MM) — браузер распарсит сам.
  if (/[zZ]$|[+\-]\d{2}:?\d{2}$/.test(s)) return new Date(s);

  // SQLite: "YYYY-MM-DD HH:MM:SS[.fff]" → нормализуем и помечаем как UTC.
  const iso = s.replace(' ', 'T');
  return new Date(iso + 'Z');
}

const TZ = 'Asia/Tashkent';

const DATE_TIME_OPTS = {
  day: '2-digit', month: '2-digit', year: '2-digit',
  hour: '2-digit', minute: '2-digit',
  timeZone: TZ,
};

const TIME_ONLY_OPTS = {
  hour: '2-digit', minute: '2-digit', second: '2-digit',
  timeZone: TZ,
};

export function fmtDate(input) {
  const d = parseUtcDate(input);
  if (!d || isNaN(d)) return '—';
  return d.toLocaleString('ru-RU', DATE_TIME_OPTS);
}

export function fmtTime(input) {
  const d = parseUtcDate(input);
  if (!d || isNaN(d)) return '—';
  return d.toLocaleTimeString('ru-RU', TIME_ONLY_OPTS);
}
